import React from 'react';
import { ComprehensiveAnalytics } from '../../ComprehensiveAnalytics';
import type {
  CarrierProfile as CarrierProfileType,
  Inspection,
  Violation,
  Crash,
  Vehicle,
} from '../../../types/api';
import type { BASICScore, ObservedUnitsData } from '../CarrierTabs.types';

export interface AnalyticsProps {
  profile: CarrierProfileType;
  violations: Violation[];
  crashes: Crash[];
  inspections: Inspection[];
  basics: BASICScore[];
  vehicles: Vehicle[];
  observedUnits: ObservedUnitsData | null;
  dotNumber: number;
}

const Analytics: React.FC<AnalyticsProps> = ({
  profile,
  violations,
  crashes,
  inspections,
  basics,
  vehicles,
  observedUnits,
  dotNumber,
}) => {
  return (
    <ComprehensiveAnalytics
      profile={profile}
      violations={violations}
      crashes={crashes}
      inspections={inspections}
      basics={basics}
      vehicles={vehicles}
      observedUnits={observedUnits}
      census={null}
      dotNumber={dotNumber || undefined}
    />
  );
};

export default Analytics;
